import useReveal from '../hooks/useReveal';

export default function SenpaiCard({ senpai }) {
  const ref = useReveal();

  return (
    <article ref={ref} className="senpai-card reveal">
      <div className="senpai-card__media">
        {senpai.image && (
          <img
            className="senpai-card__img"
            src={senpai.image}
            alt={senpai.name}
            style={{
              objectPosition: senpai.objectPosition,
              transformOrigin: senpai.objectPosition
            }}
          />
        )}
      </div>
      <div className="senpai-card__caption">
        <div className="senpai-card__belt-row">
          <span className="senpai-card__belt-mark" style={{ background: senpai.beltColor }} />
          <span className="senpai-card__belt">{senpai.belt}</span>
        </div>
        <h3 className="senpai-card__name">{senpai.name}</h3>
      </div>
    </article>
  );
}
